<template>
  <div class="json-tree" :style="{ paddingLeft: depth ? '16px' : '0' }">
    <template v-if="isObject || isArray">
      <span class="toggle" @click="collapsed = !collapsed">{{ collapsed ? '▶' : '▼' }}</span>
      <span class="bracket">{{ isArray ? '[' : '{' }}</span>
      <span v-if="collapsed" class="preview" @click="collapsed = false">
        {{ isArray ? `${Object.keys(data).length} items` : `${Object.keys(data).length} keys` }}
      </span>
      <span v-if="collapsed" class="bracket">{{ isArray ? ']' : '}' }}</span>
      <template v-if="!collapsed">
        <div v-for="(value, key) in data" :key="key" class="json-entry">
          <span v-if="!isArray" class="json-key">{{ key }}</span>
          <span v-if="!isArray" class="colon">:&nbsp;</span>
          <span v-if="isArray" class="json-index">{{ key }}</span>
          <span v-if="isArray" class="colon">:&nbsp;</span>
          <JsonTree v-if="isComplex(value)" :data="value" :depth="depth + 1" />
          <span v-else :class="valueClass(value)">{{ formatValue(value) }}</span>
        </div>
        <div class="bracket">{{ isArray ? ']' : '}' }}</div>
      </template>
    </template>
    <span v-else :class="valueClass(data)">{{ formatValue(data) }}</span>
  </div>
</template>

<script>
export default {
  name: 'JsonTree',
  props: {
    data: {
      default: null
    },
    depth: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      collapsed: this.depth > 2
    }
  },
  computed: {
    isObject () {
      return this.data !== null && typeof this.data === 'object' && !Array.isArray(this.data)
    },
    isArray () {
      return Array.isArray(this.data)
    }
  },
  methods: {
    isComplex (value) {
      return value !== null && typeof value === 'object'
    },
    valueClass (value) {
      if (value === null || value === undefined) return 'json-null'
      if (typeof value === 'string') return 'json-string'
      if (typeof value === 'number') return 'json-number'
      if (typeof value === 'boolean') return 'json-boolean'
      return ''
    },
    formatValue (value) {
      if (value === null) return 'null'
      if (value === undefined) return 'undefined'
      if (typeof value === 'string') return `"${value}"`
      return String(value)
    }
  }
}
</script>

<style scoped>
.json-tree {
  font-family: 'Source Code Pro', 'Menlo', 'Monaco', 'Consolas', monospace;
  font-size: 12px;
  line-height: 1.6;
  text-align: left;
}
.toggle {
  cursor: pointer;
  user-select: none;
  font-size: 10px;
  margin-right: 3px;
  color: #727272;
}
.bracket {
  color: #333;
}
.preview {
  color: #888;
  font-style: italic;
  cursor: pointer;
  margin: 0 4px;
  font-size: 11px;
}
.json-entry {
  padding-left: 16px;
}
.json-key {
  color: #881391;
}
.json-index {
  color: #1a1aa6;
}
.colon {
  color: #333;
}
.json-string {
  color: #c41a16;
}
.json-number {
  color: #1a1aa6;
}
.json-boolean {
  color: #1a1aa6;
}
.json-null {
  color: #808080;
}
</style>
